import api from "./Urls";
import {
  getStoredToken,
  saveStoredUser,
} from "./authStorage";

const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 8000,
  maximumAge: 5 * 60 * 1000,
};

const getCurrentCoordinates = () =>
  new Promise((resolve, reject) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        resolve({
          latitude: coords.latitude,
          longitude: coords.longitude,
          accuracy: coords.accuracy,
        });
      },
      reject,
      GEOLOCATION_OPTIONS
    );
  });

const getGeolocationStatus = (error) => {
  if (!error) return "unavailable";

  switch (error.code) {
    case 1:
      return "denied";
    case 2:
      return "unavailable";
    case 3:
      return "timeout";
    default:
      return "unavailable";
  }
};

/**
 * Requests the current browser location after authentication, sends only the
 * coordinates needed for reverse-geocoding to Spring Boot, and stores the
 * returned textual profile location.
 *
 * Login/signup must never fail just because location is unavailable.
 */
export const syncCurrentLocationAfterAuth = async () => {
  const token = getStoredToken();

  if (!token) {
    return { status: "not-authenticated" };
  }

  let coordinates;

  try {
    coordinates = await getCurrentCoordinates();
  } catch (error) {
    return {
      status: getGeolocationStatus(error),
      error,
    };
  }

  try {
    const res = await api.put(
      "/api/users/me/location",
      {
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
      },
      {
        // Explicitly provide the token here so location sync does not depend
        // on Axios interceptor timing immediately after saveAuthSession().
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    saveStoredUser(res.data);

    return {
      status: "updated",
      user: res.data,
    };
  } catch (error) {
    console.warn("Unable to sync current location:", error);

    return {
      status: "server-error",
      error,
    };
  }
};
